import React from "react";
import styled from "styled-components";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { ButtonText } from "@loanbossinc/component-library";

const StyledCard = styled(Card)`
  && {
    font-family: Work Sans;
    width: 360px;
    box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
    border-radius: 8px;
    text-align: center;
    padding: 16px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

const StyledCardContent = styled(CardContent)`
  && {
    width: 330px;
    padding: 0;
  }
`;

const StyledTitle = styled.h1`
  && {
    text-align: left;
    margin: 11px 0;
    font-family: 'Lexend';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    justify-content: left;
  }
`;

const StyledSubtitle = styled.h2`
  font-family: 'Lexend';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
`;

const StyledButtonContainer = styled.div`{
  display: flex;
  flex: 1;
  justify-content: end;
}`;

const StyledButtonText = styled(ButtonText)`
  && {
    width: 100%;
    justify-content: left;
    .label {
      margin-left: 14px;
    }
  }
`;

const CardActionButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 14px 24px;
  border: 1px solid #1468A5;
  border-radius: 8px;
  color: #1468A5;
  font-family: 'Lexend';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s ease;
  margin: 20px 0 -24px 0;
  
  &:active {
    background: rgba(20, 104, 165, 0.1);
  }
`;

const DealLiteHeroCard = (props) => {
  const companyName = props.deal?.sponsorCompany?.name;
  return (
    <StyledCard>
      <StyledCardContent>
        <StyledButtonContainer>
          <StyledButtonText label="Back to Dashboard" iconName="arrow_forward" reverse={true} onClick={() => (props.onBackButtonClick ? props.onBackButtonClick() : props.history.goBack())} />
        </StyledButtonContainer>
        <StyledTitle>{ props.title }</StyledTitle>
        { companyName && 
          <StyledSubtitle>{ companyName }</StyledSubtitle>
        }
        <CardActionButton onClick={props.onActionButtonClick}>Prepayment Calculator</CardActionButton>
      </StyledCardContent>
    </StyledCard>
  );
};

export default DealLiteHeroCard;
